export const ID_FILTER_CODE = 'code';
export const ID_FILTER_NAME = 'name';
export const ID_FILTER_TYPOLOGY = 'mobility-store-typology';
export const ID_FILTER_SEARCH = 'search';